import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import {
  FaProjectDiagram,
  FaSmile,
  FaGlobe,
  FaAward,
} from "react-icons/fa";
import "../App.css";

const Counter = ({ target, label, Icon }) => {
  const ref = useRef();
  const isInView = useInView(ref, { once: true });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isInView) return;

    let start = 0;
    const duration = 2000;
    const incrementTime = 20;
    const step = target / (duration / incrementTime);

    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        start = target;
        clearInterval(timer);
      }
      setCount(Math.floor(start));
    }, incrementTime);

    return () => clearInterval(timer);
  }, [isInView, target]);

  return (
    <motion.div
      ref={ref}
      className="stat-card"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="stat-icon">
        <Icon size={40} />
      </div>
      <div className="stat-number">{count}+</div>
      <div className="stat-label">{label}</div>
    </motion.div>
  );
};

const StatsCounter = () => {
  return (
    <section className="stats-section">
      <Counter target={200} label="Completed Projects" Icon={FaProjectDiagram} />
      <Counter target={100} label="Happy Customers" Icon={FaSmile} />
      <Counter target={27} label="Countries Reached" Icon={FaGlobe} />
      <Counter target={6} label="Years of Experience" Icon={FaAward} />
    </section>
  );
};

export default StatsCounter;
